// @flow

import * as ACTIONS from '../constants/actions';
import { dashboardReports } from '../services/api';
import * as ReportModel from '../models/report';
import { errorToast } from '../utils/toaster';

export const fetch = (options) => async (dispatch, getState) => {
  try {
    dispatch({ type: ACTIONS.FETCH_REPORTS_REQUEST });

    const fresh = options && options.fresh;
    const response = fresh
      ? await dashboardReports.fetchFresh()
      : await dashboardReports.fetch();

    const payload = {
      dashboardReports: response.map((report) => {
        return ReportModel.create({
          id: report.id,
          name: report.name,
          description: report.description,
          config: report.config,
          status: report.status,
          order: report.order,
          ownerId: report.ownerId,
          createdAt: report.createdAt,
          updatedAt: report.updatedAt,
          // keep legacy created for any existing consumers
          created: report.createdAt,
        });
      }),
    };

    dispatch({ type: ACTIONS.FETCH_REPORTS_SUCCESS, payload });
  } catch (error) {
    errorToast({ message: 'Error fetching reports.', timeout: 2500 });
    console.error(error);
    dispatch({ type: ACTIONS.FETCH_REPORTS_ERROR });
  }
};

export const saveDashboardReport =
  ({ name, description, config }) =>
  async (dispatch, getState) => {
    try {
      const payload = {
        name: String(name || '').trim(),
        description: String(description || '').trim(),
        config: config || {},
        status: 'active',
        order: 999,
      };
      const created = await dashboardReports.create(payload);
      // Refresh list so My Reports updates (bypass cache)
      await dispatch(fetch({ fresh: true }));
      return created;
    } catch (error) {
      handleReportSaveError(error);
      throw error;
    }
  };

export const deleteDashboardReport = (id) => async (dispatch, getState) => {
  try {
    await dashboardReports.delete(id);
    await dispatch(fetch({ fresh: true }));
    return true;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const shareDashboardReport = (id) => async (dispatch, getState) => {
  try {
    await dashboardReports.share(id);
    await dispatch(fetch({ fresh: true }));
    return true;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDashboardReport = (id, { name, description, config }) =>
  async (dispatch, getState) => {
    try {
      const payload = {
        name: String(name || '').trim(),
        description: String(description || '').trim(),
        config: config || {},
      };
      await dashboardReports.update(id, payload);
      await dispatch(fetch({ fresh: true }));
      return true;
    } catch (error) {
      handleReportSaveError(error);
      throw error;
    }
  };

const GENERIC_MESSAGE = 'We are unable to save your report, please try again later';
const DUPLICATE_MESSAGE = 'A report with this name already exists, please use a unique report name';

function handleReportSaveError(error) {
  try {
    const status = error && error.response && error.response.status;
    if (Number(status) === 409) {
      errorToast({ message: DUPLICATE_MESSAGE, timeout: 4000 });
    } else {
      errorToast({ message: GENERIC_MESSAGE, timeout: 4000 });
    }
    // eslint-disable-next-line no-console
    console.error(error);
  } catch (e) {
    // Fallback to generic message if something unexpected occurs
    errorToast({ message: GENERIC_MESSAGE, timeout: 4000 });
    // eslint-disable-next-line no-console
    console.error(error || e);
  }
}
